import { useEffect, useState } from "react";
import { ProjectCard } from "./ProjectCard";
import { Row } from "react-bootstrap";

const MediumBlog = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        fetch(
        "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@aditya.p22"
        )
        .then((res) => res.json())
        .then((data) => {
            setPosts(data.items); // Get all posts without slicing
        });
    }, []);

    return (
        <div className="row">
            <Row>
                {posts.map((post) => (
                    <ProjectCard
                        key={post.guid}
                        title={post.title}
                        description={
                            post.description
                                ? post.description.replace(/<[^>]+>/g, "").slice(0, 200) + "..."
                                : "No description available"
                        }
                        link={post.link}
                    />
                ))}
            </Row>
        </div>
    );
};

export default MediumBlog;